import { makeStyles } from '@material-ui/core';

const useCheckedInStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
}));

export default useCheckedInStyles;
